import Coupon from '@/models/Coupon';

interface CouponCodeData {
  id: string;
  code: string;
  claimed_at: string;
  redeemed_at?: string | null;
  status: string;
  deadline?: string;
}

interface CouponRawData {
  name: string;
  description: string | null;
  discount_type: "money" | "rate";
  discount_tiers: Array<{min: string, discount: string}>;
  max_discount_amount: number;
  stackable: boolean;
  redeem_start_at: string | null;
  redeem_end_at: string | null;
  currency: string;
  country: string | null;
  timezone: string;
  uni_coupon_codes: CouponCodeData[];
}

export default class Coupons {
  private coupons: Coupon[] = [];

  constructor(coupons: CouponRawData[] = []) {
    coupons.forEach((coupon) => {
      coupon.uni_coupon_codes.forEach((code) => {
        this.coupons.push(
          new Coupon({
            id: code.id,
            code: code.code,
            claimedAt: code.claimed_at,
            redeemedAt: code.redeemed_at || '',
            status: code.status as any,
            name: coupon.name,
            description: coupon.description,
            discountType: coupon.discount_type,
            discountTiers: coupon.discount_tiers,
            maxDiscountAmount: coupon.max_discount_amount,
            stackable: coupon.stackable,
            redeemStartAt: coupon.redeem_start_at || '',
            redeemEndAt: code.deadline || coupon.redeem_end_at || '',
            currency: coupon.currency,
            country: coupon.country,
            timeZone: coupon.timezone,
          }),
        );
      });
    });
  }

  get isEmpty(): boolean {
    return this.coupons.length === 0;
  }

  get count(): number {
    return this.coupons.length;
  }

  get sortedCoupons(): Coupon[] {
    // 排序 按照最近領取時間 最近領取的排前面

    const rawCoupons = [...this.coupons];

    const isStarted = rawCoupons
      .filter((coupon) => coupon.isRedeemStarted)
      .sort((a, b) => (b.claimedAtUTC?.getTime() || 0) - (a.claimedAtUTC?.getTime() || 0));
    const isNotStarted = rawCoupons
      .filter((coupon) => !coupon.isRedeemStarted)
      .sort((a, b) => (b.claimedAtUTC?.getTime() || 0) - (a.claimedAtUTC?.getTime() || 0));

    return [...isStarted, ...isNotStarted];
  }

  getCouponById(id: string): Coupon | undefined {
    return this.coupons.find((coupon) => coupon.id === id);
  }

  insertCoupons(coupons: CouponRawData[]): void {
    // 要記得比對 ID 避免重複寫入
    coupons.forEach((coupon) => {
      coupon.uni_coupon_codes.forEach((code) => {
        const existCoupon = this.getCouponById(code.id);
        if (existCoupon) {
          existCoupon.update({
            redeemedAt: code.redeemed_at || '',
            status: code.status as any,
          });
        } else {
          this.coupons.push(
            new Coupon({
              id: code.id,
              code: code.code,
              claimedAt: code.claimed_at,
              redeemedAt: code.redeemed_at || '',
              status: code.status as any,
              name: coupon.name,
              description: coupon.description,
              discountType: coupon.discount_type,
              discountTiers: coupon.discount_tiers,
              maxDiscountAmount: coupon.max_discount_amount,
              stackable: coupon.stackable,
              redeemStartAt: coupon.redeem_start_at || '',
              redeemEndAt: coupon.redeem_end_at || '',
              currency: coupon.currency,
              country: coupon.country,
              timeZone: coupon.timezone,
            }),
          );
        }
      });
    });
  }
}